import React from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import 'animate.css';

import { ReactQueryContainer } from 'config/react-query';
import * as Sentry from '@sentry/react';
import configureStore, { history } from './store';
import App from './containers/App';
import './config/sentry';

export const store = configureStore();

const MainApp = () => (
  <Sentry.ErrorBoundary fallback={<p>Ha ocurrido un error.</p>}>
    <ReactQueryContainer>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <Switch>
            <Sentry.ErrorBoundary fallback={<p>Ha ocurrido un error.</p>}>
              <Route path="/" component={App} />
            </Sentry.ErrorBoundary>
          </Switch>
        </ConnectedRouter>
      </Provider>
    </ReactQueryContainer>
  </Sentry.ErrorBoundary>
);

export default MainApp;
